import * as React from 'react';

import './icon-styles.css';

export const ItalicIcon = () => {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
        >
            <path
                className="icon-italic"
                d="M18.36,8.1c.19,0,.26.09.22.28l-3.1,13.56a.33.33,0,0,1-.35.29H13.32c-.18,0-.26-.09-.21-.29l3.1-13.56a.32.32,0,0,1,.34-.28Z"
            />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/icons/pt-icon-italic.tsx